import {
  AppendSftpKeyResponse,
  SetEnabledSftpPosConfigVenue,
  SftpIntegrationUser,
  SftpPubKeyRequest,
  VenuesWithSftpConfig,
  VenuesWithSftpConfigResponse,
} from './types';
import merchantGatewayApi from '../../api';

const BaseEndpoint = '/pos-integration-service/datamapper/credentials/sftp';

export const fetchSftpIntegrationUser = (merchantId: string): Promise<SftpIntegrationUser> =>
  merchantGatewayApi.get<SftpIntegrationUser>(`${BaseEndpoint}/${merchantId}`).then(response => response.data);

export const createSftpIntegrationUser = (merchantId: string, data: SftpPubKeyRequest): Promise<SftpIntegrationUser> =>
  merchantGatewayApi.put<SftpIntegrationUser>(`${BaseEndpoint}/${merchantId}`, data).then(response => response.data);

export const appendSshKeyToIntegrationUser = (
  merchantId: string,
  data: SftpPubKeyRequest,
): Promise<AppendSftpKeyResponse> =>
  merchantGatewayApi
    .post<AppendSftpKeyResponse>(`${BaseEndpoint}/${merchantId}/ssh`, data)
    .then(response => response.data);

export const deleteSshKeyFromIntegrationUser = (merchantId: string, sshKeyId: string): Promise<boolean> =>
  merchantGatewayApi.delete<boolean>(`${BaseEndpoint}/${merchantId}/ssh/${sshKeyId}`).then(() => true);

export const fetchVenuesWithSftpConfig = (merchantId: string): Promise<VenuesWithSftpConfig[]> =>
  merchantGatewayApi
    .get<VenuesWithSftpConfigResponse>(`${BaseEndpoint}/${merchantId}/posconfig/venues`)
    .then(response => response.data.data);

export const setEnabledSftpConfigOfVenue = (merchantId: string, data: SetEnabledSftpPosConfigVenue): Promise<boolean> =>
  merchantGatewayApi
    .post(`${BaseEndpoint}/${merchantId}/posconfig/${data.venue_id}`, { configs: [data] })
    .then(response => !!response.data);
